// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero--hero--2pm1b","hero__title":"Hero--hero__title--M-5H_","hero__subtitle":"Hero--hero__subtitle--_NUtA","hero__contentHeading":"Hero--hero__contentHeading--2hf5e"};